import styled from 'styled-components';

import Container from 'styled/components/Container';

export default styled(Container)`
  display: grid;
  grid-gap: 11px;
  grid-template-columns: 1fr minmax(0, 650px) 1fr;
  max-width: 1378px; // in case on really big monitors
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;
